<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Concierge Bell" class="d-icon d-icon--concierge-bell" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.5 9a1.5 1.5 0 0 0-1.02-1.421A4.5 4.5 0 0 0 6.5 3.528V2.5H7a.5.5 0 0 0 0-1H5a.5.5 0 0 0 0 1h.5v1.028a4.5 4.5 0 0 0-3.98 4.051A1.5 1.5 0 0 0 .5 9v1a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9ZM2 8.5a.5.5 0 0 0-.5.5v.5h9V9a.5.5 0 0 0-.5-.5H2Zm6.475-2.975A3.5 3.5 0 0 0 2.535 7.5h6.93a3.5 3.5 0 0 0-.99-1.975Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconConciergeBell',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
